import { ref } from "vue";

/**
 * 合同审查结果页共享状态
 * - 由 ReviewResult.vue 写入（props 同步 + 审查接口回调）
 * - 由 kevinHome.vue 头部直接消费（响应式，无需轮询）
 *
 * status：'reviewing' = 审查中 | 'completed' = 审查完成
 */
export const crContractName = ref("动产买卖合同");
export const crStatus = ref("reviewing");

/**
 * 当前审查会话 ID
 * - 由 ReviewResult.vue 在 GetOrStartReview 成功后写入
 * - 三列面板及其他位置按需读取
 */
export const crReviewId = ref(null);

/**
 * 审查结果（GetOrStartReview 接口的完整返回）
 * - 由 ReviewResult.vue 在 GetOrStartReview 成功后写入
 * - 由 TaskPanel / DocPanel / OpinionPanel 消费
 */
export const crReviewResult = ref(null);

